import { gql } from '@apollo/client';

export const submitFeedbackMutation = gql`
  mutation SubmitFeedback(
    $slackChannelId: String!
    $type: String!
    $message: String!
    $page: String!
  ) {
    submitFeedback(
      slackChannelId: $slackChannelId
      type: $type
      message: $message
      page: $page
    ) {
      success
      viewFeedback
    }
  }
`;
